import { Grid } from '@mui/material';
import { HSpacer, RCDialog, RoutalSelect, RoutalSelectMultiSelectOption, VSpacer } from '@nx-smartmonkey/ui';
import { useState } from 'react';

import IconSuccess from '../../../../../../assets/img/data-importer/icon-success.svg';
import Button from '../../../../../../react-components/Button';
import Text from '../../../../../../react-components/Text';

export const SheetSelector = ({
  open,
  sheets,
  fileName,
  onDialogClose,
}: {
  open: boolean;
  sheets: string[];
  fileName: string;
  onDialogClose: (sheetName?: string) => void;
}) => {
  const [selectedSheet, setSelectedSheet] = useState<string>(sheets[0]);

  return (
    <RCDialog
      open={open}
      showCrossCloseButton={false}
      showHeader={false}
      onCloseDialog={() => {
        onDialogClose();
      }}
      footerContent={
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Button variant="flat" styleType="secondary" onClick={() => onDialogClose()} intlId="cancel" />

          <Button onClick={() => onDialogClose(selectedSheet)} intlId="continue" />
        </Grid>
      }
    >
      <Grid container direction="column" justifyContent="center" alignItems="center">
        <Text
          variant="h6"
          isBold
          intlId="plans.dialogs.upload_stops.load_file.sheet_selector.title"
          intlValues={{ fileName }}
        />
      </Grid>

      <VSpacer large />

      <Grid container direction="row" alignItems="center">
        <img alt="" src={IconSuccess} width="20px" draggable="false" />

        <HSpacer small />

        <Text intlId="plans.dialogs.upload_stops.load_file.sheet_selector.file_loaded" />
      </Grid>

      <VSpacer small />

      <Grid container direction="row" alignItems="center">
        <img alt="" src={IconSuccess} width="20px" draggable="false" />

        <HSpacer small />

        <Text intlId="plans.dialogs.upload_stops.load_file.sheet_selector.sheets_loaded" />
      </Grid>

      <VSpacer large />

      <Text variant="label" intlId="plans.dialogs.upload_stops.load_file.sheet_selector.select_sheet" />

      <VSpacer medium />

      <RoutalSelect
        id="sheet-selector"
        popoverProps={{
          options: sheets.map(
            (sheet, index): RoutalSelectMultiSelectOption => ({
              key: `${sheet}-${index}`,
              content: <Text style={{ cursor: `pointer` }}>{sheet}</Text>,
              onClick: () => {
                setSelectedSheet(sheet);
              },
            })
          ),
        }}
      >
        <Text
          style={{
            cursor: `pointer`,
            width: `100%`,
            textAlign: `justify`,
          }}
        >
          {selectedSheet}
        </Text>
      </RoutalSelect>
    </RCDialog>
  );
};
